<template>
  <div class="edit-table">
    <div v-for="(item, k) in detailVos" :key="k" class="list-wrap">
      <el-col :span="8">
        <el-form-item :label="item.indicatorName">
        <el-input disabled :value="item.indicatorRate"></el-input>
        </el-form-item>
      </el-col>
    </div>
  </div>
</template>

<script>
import request from '@/found/utils/request';

export default {
  name: 'ContainOrg',
  props: {
    code: String,
    value: Array,
  },
  data() {
    return {
      detailVos: [],
    };
  },
  components: {},
  watch: {
    value() {
      this.detailVos = this.value;
    },
  },
  mounted() {
    if (this.saveRef) {
      this.saveRef(this);
    }
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>

</style>
